import React from 'react';
import { Spinner, Alert } from '@gsa/afp-component-library';
import {
    useCurrentUser, useTitle, InternalError
} from '@gsa/afp-shared-ui-utils';
import { useRouteError } from 'react-router-dom';

const LOGOUT_URL = '/auth';

export default function RouteError() {
    useTitle('Error');
    const { isLoading, currentUser, isLoggedIn } = useCurrentUser();

    // eslint-disable-next-line  @typescript-eslint/no-unused-vars
    const { networkError, stack } = useRouteError();
    if (isLoading)
        return <Spinner data-testid="loading-spinner" className="padding-y-9" />;

    if (networkError === 'No current user' || !currentUser || !isLoggedIn)
        window.location.replace(LOGOUT_URL);

    return (
        <div className="margin-bottom-5">
            <InternalError id="system-error" /> 
            {window.AFP_CONFIG.showGraphqlErrors && (
                <Alert
                    type="error"
                    heading="Uncaught error"
                >
                    <pre><code>{stack}</code></pre>
                </Alert>
            )}
        </div>
    );
}